<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Subgrupos de questões
        </div>
        <div class="text-body-2 text--secondary mt-1">
          Esses são os subgrupos de questões que poderão ser utilizados na avaliação.<br>
          (ex. aluno pode escolher entre fazer questões de ingles ou espanhol dependendo do subgrupo que ele selcionar)
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="openNewChoiceGroupDialog"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon> Novo subgrupo
      </v-btn>
    </div>
    <v-simple-table
      v-if="questionsView"
      fixed-header
    >
      <v-progress-linear
        v-if="loadingList"
        color="amber"
        indeterminate
      />
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="questionsGroup"
          :items-per-page="10"
          item-key="id"
        >
          <template #item.title="{ item }">
            <router-link :to="{ name: 'exams.examId.groups.groupId.choice.choiceId', params: { examId: examId, groupId: group.id, choiceId: item.id } }">
              {{ item.title }}
            </router-link>
          </template>
          <template #item.created_at="{ item }">
            <div class="d-flex flex-row justify-center">
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                @click="openEditChoiceGroupDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                @click="deleteQuestionGroupChoices(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import EditChoiceGroupDialog from './EditChoiceGroupDialog.vue'
import NewChoiceGroupDialog from './NewChoiceGroupDialog.vue'
import utils from '@/api/utils.js'

export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],

  props: {
    group: { type: Object, required: true }
  },

  data () {
    return {
      loadingList: false,
      questionsGroup: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Titulo',
          align: 'start',
          value: 'title'
        },
        {
          text: 'Subtitulo',
          align: 'start',
          value: 'subtitle'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'created_at'
        }
      ]
    }
  },
  computed: {
    examId () {
      return this.$route.params.examId
    },
    questionsView () {
      return utils.checkPermissions('questions.view-any')
    },
    questionsCreate () {
      return utils.checkPermissions('questions.create')
    },
    questionsUpdate () {
      return !utils.checkPermissions('grade-level-groups.update-any')
    },
    questionsDelete () {
      return !utils.checkPermissions('grade-level-groups.delete')
    }
  },
  watch: {
  },
  async mounted () {
    await this.listQuestionGroupChoices()
  },
  methods: {
    async listQuestionGroupChoices () {
      this.loadingList = true
      try {
        this.questionsGroup = await this.$api.listQuestionGroupChoices(this.group.id)
        this.$emit('reload')
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar grupos de questões.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loadingList = false
      }
    },

    openNewChoiceGroupDialog () {
      this.$dialog.custom(NewChoiceGroupDialog).with({ groupId: parseInt(this.group.id) }).show()
        .then(async (newGroup) => {
          if (newGroup) {
            await this.listQuestionGroupChoices()
          }
        })
    },

    openEditChoiceGroupDialog (item) {
      this.$dialog.custom(EditChoiceGroupDialog).with({ group: item }).show()
        .then(async (edited) => {
          if (edited) {
            await this.listQuestionGroupChoices()
          }
        })
    },

    async deleteQuestionGroupChoices (group) {
      this.$dialog.confirm('Apagar Subgrupo de questões?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.loading = true
          try {
            await this.$api.deleteQuestionGroupChoices(group.id)
            this.$store.dispatch('setSnackBar', { text: 'Subgrupo excluído com sucesso.' })
            await this.listQuestionGroupChoices()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar excluir o Subgrupo.', color: 'red' })
          } finally {
            this.loading = false
          }
        })
        .show()
    }
  }
}
</script>
